import { getMapboxAccessTokenSync } from '@/config/mapbox';

type MappablePlace = {
  coordinates?: { latitude: number; longitude: number } | null;
};

const PIN_COLORS = ['285A98', '56B27F', 'F26C4F', '9B59B6', 'E67E22', '1ABC9C', '3498DB', 'E74C3C'];

export const buildTripMapSnapshotUrl = (
  places: MappablePlace[],
  options?: { width?: number; height?: number; retina?: boolean },
): string | null => {
  const token = getMapboxAccessTokenSync();
  if (!token) return null;

  const mapped = places.filter(
    (place) =>
      typeof place.coordinates?.latitude === 'number' &&
      Number.isFinite(place.coordinates.latitude) &&
      typeof place.coordinates?.longitude === 'number' &&
      Number.isFinite(place.coordinates.longitude),
  );
  if (mapped.length === 0) return null;

  const overlays = mapped.slice(0, 12).map((place, index) => {
    const { longitude, latitude } = place.coordinates!;
    const label = String.fromCharCode(97 + (index % 26));
    const color = PIN_COLORS[index % PIN_COLORS.length];
    return `pin-s-${label}+${color}(${longitude},${latitude})`;
  });

  const width = options?.width ?? 640;
  const height = options?.height ?? 300;
  const retina = options?.retina === false ? '' : '@2x';
  const overlayPath = overlays.join(',');

  return `https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/${overlayPath}/auto/${width}x${height}${retina}?access_token=${token}&padding=48`;
};
